import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddDisciplinaryActions,
  fetchUploadDisciplinaryActionDocument,
  getDisciplinaryActionDisplayIdFromResponse,
  fetchAddLicenses,
  fetchDeleteLicenses,
  fetchDisciplinaryMoreDetails,
  fetchLicenseInformation,
  fetchLicenseMoreDetails,
  fetchLicenseTypes,
  fetchUpdateDisciplinaryActions,
  fetchUpdateLicenses,
  fetchVerifyDisciplinaryAction,
} from "../../../store/ProviderInfo/ProviderLicenseActions";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import "bootstrap-icons/font/bootstrap-icons.scss";
import "./ProviderLicense.scss";
import statesData, { DATE_REGEX, formatDateUnrelatedTimezone } from "../../../utils/commonUtilities";
import boardStatusIcon from "../../../assets/Icons/active_Icon.svg";
import { useLocation } from "react-router-dom";
import { MyAccountContext } from "../../../App";
import OutsideClickHandler from "../../../common/OutsideClickHandler";

const ProviderLicenseSection = ({
  providerId,
  onlyPopup = false,
  closePopupCallback = () => {},
  openAddLicensePopup,
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [editId, setEditId] = useState();
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [openAccordian, setOpenAccordian] = useState({});
  const [selectedLicense, setSelectedLicense] = useState("");
  const [stateCode, setStateCode] = useState(false);
  const [selectedTypeItem, setSelectedTypeItem] = useState(null);
  const [dropdownTypeData, setDropdownTypeData] = useState([]);
  const [openBoardDocDisId, setOpenBoardDocDisId] = useState("");
  const [licenceDataMoreDetailsMap, setLicenceDataMoreDetailsMap] = useState(
    {}
  );
  const [disciplinaryMoreDetailsMap, setDisciplinaryMoreDetailsMap] = useState(
    {}
  );
  const [openPopupDisciplinaryActions, setPopupDisciplinaryActions] =
    useState(false);
  const [activeLicenseId, setActiveLicenseId] = useState("");
  const [disciplinaryActionsEditId, setdisciplinaryActionsEditId] = useState();
  const [confirmDeleteDisciplinaryAction, setConfirmDeleteDisciplinaryAction] =
    useState({});
  const [editClicked, setEditClicked] = useState(false);
  const [rawFile, setRawFile] = useState([]);
  const [showError, setShowError] = useState(false);
  const [fileDesc, setFileDesc] = useState("");
  const [licenseNumber, setLicenseNumber] = useState(null);
  const [boardStatusPracticeDisId, setBoardStatusPracticeDisId] = useState("");
  const [enableLicenseSaveBtn, setEnableLicenseSaveBtn] = useState(false);
  const [disciplinaryActionDate, setDisciplinaryActionDate] = useState();
  const [disciplinaryDescription, setDisciplinaryDescription] = useState();
  const [showFutureErrorMsg, setShowFutureErrorMsg] = useState(false);
  const [enableDisciplinaryActionSaveBtn, setEnableDisciplinaryActionSaveBtn] =
    useState(false);
  const [enableEditSaveBtn, setEnableEditSaveBtn] = useState(true);

  const location = useLocation();
  const locationData = location.pathname.split("/");

  const { grantedRoles = [] } = useContext(MyAccountContext) || {};
  const hasAdminRole = grantedRoles.includes("ROLE_ADMIN");

  const [prvId, setPrvId] = useState(providerId ? providerId : locationData[2]);

  const { LicenseData, LicenseError, licenseErrorMsg } = useSelector(
    (state) => state.providerLicenseInformation
  );

  const { providerOverviewData } = useSelector(
    (state) => state.providerOverviewInformation
  );

  const { isdisciplinaryActionsDataLoading, licenceDataMoreDetails } =
    useSelector((state) => state.providerLicenseMoreDetails);

  const { disciplinaryMoreDetails, isddisciplinaryMoreDetailsLoading } =
    useSelector((state) => state.providerDisciplinaryMoreDetails);

  // const stateData = [
  //   { id: 1, value: "AK" },
  //   { id: 2, value: "AL" },
  //   { id: 3, value: "CA" },
  // ];

  const stateData = statesData;

  const disciplinaryActionFormStatusData = [
    { id: 1, value: "STANDARD" },
    { id: 2, value: "WAIVED" },
    { id: 3, value: "PERMANENT" },
  ];

  const { typeData } = useSelector(
    (state) => state.providerLicenseTypesSuggestions
  );

  const StatusData = [
    { id: 1, value: "ACTIVE" },
    { id: 2, value: "PROBATION" },
    { id: 3, value: "INACTIVE" },
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (disciplinaryActionsEditId) {
      setTimeout(() => {
        setEditClicked(true);
      }, 1000);
      setEnableDisciplinaryActionSaveBtn(true);
    }
  }, [disciplinaryActionsEditId]);

  useEffect(() => {
    if (licenceDataMoreDetails && licenceDataMoreDetails.displayId) {
      setLicenceDataMoreDetailsMap((prev) => ({
        ...prev,
        [licenceDataMoreDetails.displayId]: licenceDataMoreDetails,
      }));
    }
  }, [licenceDataMoreDetails]);

  useEffect(() => {
    if (disciplinaryMoreDetails) {
      setDisciplinaryMoreDetailsMap((prev) => ({
        ...prev,
        [licenceDataMoreDetails.displayId]: disciplinaryMoreDetails,
      }));
    }
  }, [disciplinaryMoreDetails]);

  useEffect(() => {
    if (providerId) {
      setPrvId(providerId);
    } else {
      setPrvId(locationData[2]); // once route is enabled need to add actual provider ID
    }
  }, [providerId]);

  useEffect(() => {
    if (LicenseError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [LicenseError]);

  useEffect(() => {
    setOpenPopup(openAddLicensePopup);
  }, [openAddLicensePopup]);

  useEffect(() => {
    const dropDownOptions = typeData.filter((stateDropdownOption) => {
      return stateDropdownOption.state === stateCode && stateDropdownOption.displayOnSite === true;
    });

    const UpdatedValue = dropDownOptions.map((item) => {
      return {
        id: item.displayId,
        value: item.name,
      };
    });
    setDropdownTypeData(UpdatedValue);
  }, [typeData]);

  useEffect(() => {
    dispatch(fetchLicenseInformation(prvId));
    // dispatch(fetchDisciplinaryActionInformation());
  }, []);

  useEffect(() => {
    // if (!editId) {
    if ((selectedTypeItem, stateCode, licenseNumber)) {
      setEnableLicenseSaveBtn(true);
    } else {
      setEnableLicenseSaveBtn(false);
    }
    // }
  }, [selectedTypeItem, stateCode, licenseNumber]);

  useEffect(() => {
    if ((disciplinaryDescription, disciplinaryActionDate)) {
      if (disciplinaryDescription && disciplinaryActionDate) {
        setEnableDisciplinaryActionSaveBtn(true);
      } else {
        setEnableDisciplinaryActionSaveBtn(false);
      }
    }
  }, [disciplinaryDescription, disciplinaryActionDate]);

  // Global Object
  const disciplinaryActionAddEditSchema = [
    {
      component: "input",
      label: "ACTION DATE",
      type: "date",
      customDateDisplay: true,
      placeholder: "mm/dd/yyyy",
      name: "actionDate",
      defaultValue: disciplinaryActionsEditId
        ? disciplinaryActionsEditId.actionDate
        : "",
      required: true,
      // required: disciplinaryActionsEditId ? false : true,
      valueChangeCallback: (res, value) => {
        if (value && value.length === 10 && value.includes("/")) {
          const parts = value.split("/");
          if (
            parts.length === 3 &&
            parts[0].length === 2 &&
            parts[1].length === 2 &&
            parts[2].length === 4
          ) {
            setDisciplinaryActionDate(value);
          }
        }
      },
      inputProps: {
        pattern: DATE_REGEX,
      },
      disabled: disciplinaryActionsEditId?.isValidated ? true : false,
    },
    {
      component: "input",
      label: "DESCRIPTION",
      type: "text",
      name: "description",
      defaultValue: disciplinaryActionsEditId
        ? disciplinaryActionsEditId.description
        : "",
      // required: disciplinaryActionsEditId ? false : true,
      required: true,
      valueChangeCallback: (res, value) => {
        setDisciplinaryDescription(value);
      },
      onKeyChangeCallback: (res, value) => {
        setDisciplinaryDescription(value);
      },
      disabled: disciplinaryActionsEditId?.isValidated ? true : false,
    },
    {
      component: "fileUploader",
      label: "DOCUMENTS",
      name: "uploadedFile",
      onFileUploadCallback: (res) => {
        if (res) {
          setRawFile((prev) => [
            ...prev,
            { ...res, description: fileDesc || res.FILE?.name || "" },
          ]);
        } else {
          setRawFile([]);
        }
      },
      descriptionChangeCallBack: (name, value) => {
        setFileDesc(value);
        setRawFile((prev) =>
          prev.map((fileItem, index) =>
            index === prev.length - 1
              ? { ...fileItem, description: value }
              : fileItem
          )
        );
      },
    },
    {
      component: "dropdown",
      label: "STATUS",
      name: "status",
      disabled: disciplinaryActionsEditId?.isValidated ? true : false,
      dropdownOptions: disciplinaryActionFormStatusData,
      defaultValue: disciplinaryActionsEditId
        ? disciplinaryActionsEditId.status
        : "",
      required: disciplinaryActionsEditId ? true : false,
      onSelectCallBack: () => {
        // if (value) {
        //   setEnableEditSaveBtn(true);
        // } else {
        //   setEnableEditSaveBtn(false);
        // }
      },
    },
    {
      component: "input",
      label: "NOTES",
      type: "text",
      name: "notes",
      defaultValue: disciplinaryActionsEditId
        ? disciplinaryActionsEditId.note
        : "",
      // required: disciplinaryActionsEditId ? false : true,
      required: disciplinaryActionsEditId ? true : false,
      valueChangeCallback: () => {},
      disabled: disciplinaryActionsEditId?.isValidated ? true : false,
    },
  ];

  const toggleConfirmDeleteDisciplinaryAction = (displayId, value) => {
    setConfirmDeleteDisciplinaryAction((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const convertToDateFormat = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`;
  };

  const deleteAPiCall = (deleteId) => {
    dispatch(
      fetchDeleteLicenses({
        providerId: prvId,
        licenseId: deleteId,
        data: { isValid: false },
      })
    ).then(() => {
      dispatch(fetchLicenseInformation(prvId));
    });
  };
  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const handleGetDetails = (item) => {
    const id = item.displayId;
    if (licenceDataMoreDetailsMap[id]) {
      return;
    }
    dispatch(
      fetchLicenseMoreDetails({ providerId: prvId, licenseId: item.displayId })
    );
    dispatch(
      fetchDisciplinaryMoreDetails({ providerId: prvId, licenseId: id })
    );
  };

  const handleBoardDocOutsideClick = (id) => () => {
    setOpenBoardDocDisId(id === openBoardDocDisId ? "" : id);
  };

  const handleBoardDocPopoverOutsideClick = (event) => {
    if (event?.target?.closest?.(".board-popover-ralative-div")) {
      return;
    }
    if (openBoardDocDisId) {
      setOpenBoardDocDisId(null);
    }
  };

  const openBoardDocumentLink = (event, url) => {
    event.preventDefault();
    event.stopPropagation();
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const resetDisciplinaryFileState = () => {
    setRawFile([]);
    setFileDesc("");
  };

  const uploadDisciplinaryBoardDocuments = async (
    actionDisplayId,
    filesWithDescriptions
  ) => {
    if (!actionDisplayId || !filesWithDescriptions?.length) {
      return;
    }
    for (const fileItem of filesWithDescriptions) {
      if (!fileItem.FILE) {
        continue;
      }
      await dispatch(
        fetchUploadDisciplinaryActionDocument({
          providerId: prvId,
          actionDisplayId,
          file: fileItem.FILE,
          description:
            fileItem.description || fileDesc || fileItem.FILE?.name || "",
        })
      );
    }
  };

  const refreshDisciplinaryDetails = (licenseId) => {
    dispatch(
      fetchDisciplinaryMoreDetails({
        providerId: prvId,
        licenseId,
      })
    );
  };

  const handleCofirmVerify = (data) => {
    dispatch(
      fetchVerifyDisciplinaryAction({
        providerId: prvId,
        licenseId: selectedLicense,
        disciplinaryId: data.displayId,
      })
    ).then(() => {
      dispatch(
        fetchDisciplinaryMoreDetails({
          providerId: prvId,
          licenseId: selectedLicense,
        })
      );
    });
    setdisciplinaryActionsEditId(null);
  };

  const RenderDisciplinaryActionData = (displayId) => {
    if (isddisciplinaryMoreDetailsLoading) return <div> Loading ... </div>;
    const currentDisciplinaryMoreDetails =
      disciplinaryMoreDetailsMap[displayId];
    return (
      <>
        <div className="licence-header licence-top info-background ps-1 py-2">
          <span>Disciplinary Action</span>
          <a
            className="btn-license edit-button-license"
            onClick={() => {
              setActiveLicenseId(displayId);
              resetDisciplinaryFileState();
              setPopupDisciplinaryActions(!openPopup);
              setdisciplinaryActionsEditId(null);
              setTimeout(() => {
                setEditClicked(true);
              }, [1000]);
            }}
          >
            + ADD
          </a>
        </div>
        <div className="disciplinary-action-card">
          <div className="container disciplinaryActionsDataCard">
            {currentDisciplinaryMoreDetails?.map((item, index) => {
              if (item.licenseId === displayId) {
                return (
                  <div
                    className="row disciplinaryCardRow mb-4 border"
                    key={index}
                  >
                    <div className="col-6 disciplinaryheader">
                      <div className="table-content">
                        <p className="header">
                          Action Date : {item.actionDate}
                        </p>
                      </div>
                      <div className="table-content">
                        <p className="descItem">
                          <span className="descHeader">Description :</span>
                          {item.description}
                        </p>
                      </div>
                    </div>
                    <div className="col-6 disciplinaryRowHeight justify-content-end ">
                      {!item.isValidated && (
                        <>
                          {confirmDeleteDisciplinaryAction[
                            item.discipliaryId
                          ] && (
                            <span className="cancelDisciplinaryAction">
                              <a
                                className="btn-license edit-button-license"
                                onClick={() =>
                                  toggleConfirmDeleteDisciplinaryAction(
                                    item.discipliaryId,
                                    false
                                  )
                                }
                              >
                                CANCEL
                              </a>
                            </span>
                          )}
                          {hasAdminRole && (<>
                            <a
                              className={`btn-license edit-button-license me-2 ${
                                confirmDeleteDisciplinaryAction[
                                  item.discipliaryId
                                ]
                                  ? "confirm-style"
                                  : ""
                              }`}
                              onClick={() => {
                                setdisciplinaryActionsEditId(item);
                                if (
                                  confirmDeleteDisciplinaryAction[
                                    item.discipliaryId
                                  ]
                                ) {
                                  handleCofirmVerify(item);
                                } else {
                                  toggleConfirmDeleteDisciplinaryAction(
                                    item.discipliaryId,
                                    true
                                  );
                                }
                              }}
                            >
                              {confirmDeleteDisciplinaryAction[
                                item.discipliaryId
                              ]
                                ? "CONFIRM"
                                : "VERIFY"}
                            </a>
                          <div className="divider">|</div>
                          </>
                          )}
                        </>
                      )}
                      <a
                        className="btn-license edit-button-license ms-2"
                        onClick={() => {
                          resetDisciplinaryFileState();
                          setdisciplinaryActionsEditId(item);
                          setPopupDisciplinaryActions(
                            !openPopupDisciplinaryActions
                          );
                          setTimeout(() => {
                            setEditClicked(true);
                          }, [1000]);
                        }}
                      >
                        EDIT
                      </a>
                    </div>
                    <div className="col-3 border border-bottom-0 border-end-0 border-start-0">
                      <div className="table-content">
                        <p className="header">Status</p>
                        <p className="headerValue">{item.status}</p>
                      </div>
                    </div>
                    <div className="col-3 border border-bottom-0 border-end-0 ">
                      <div className="table-content board-doc-tabel-content">
                        <p className="header">Board Documents</p>
                        <div className="headerValue">
                          <div className="linkBtn board-popover-ralative-div">
                            {Number(item.boardDocCount) > 0 ? (
                              <OutsideClickHandler
                                onClickOutside={handleBoardDocPopoverOutsideClick}
                              >
                                <div>
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleBoardDocOutsideClick(
                                        item.displayId
                                      )();
                                    }}
                                  >
                                    {item.boardDocCount} Document(s)
                                  </a>
                                  {openBoardDocDisId === item?.displayId && (
                                    <span
                                      className="practice-popover-contect"
                                      onMouseDown={(e) => e.stopPropagation()}
                                    >
                                      <div className="arrow"></div>
                                      <ul>
                                        {item.actionDocuments?.map(
                                          (doc, index) => {
                                            const documentUrl =
                                              doc?.url || doc?.document_url;
                                            return (
                                              <li key={index}>
                                                <a
                                                  href={documentUrl || "#"}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  onClick={(e) =>
                                                    openBoardDocumentLink(
                                                      e,
                                                      documentUrl
                                                    )
                                                  }
                                                >
                                                  {doc.description}
                                                </a>
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    </span>
                                  )}
                                </div>
                              </OutsideClickHandler>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-3 border border-bottom-0 border-end-0 ">
                      <div className="table-content">
                        <p className="header">Review User</p>
                        <p className="headerValue">{item.reviewUser}</p>
                      </div>
                    </div>
                    <div className="col-3 border border-bottom-0 border-end-0 ">
                      <div className="table-content">
                        <p className="header">Notes</p>
                        <p className="headerValue">{item.note}</p>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </>
    );
  };
  const RenderLicenseMoreDetails = (item, index) => {
    if (isdisciplinaryActionsDataLoading) return <div> Loading ... </div>;
    const selectedLicenceDataMoreDetails =
      licenceDataMoreDetailsMap[item.displayId] || {};
    if (!selectedLicenceDataMoreDetails) return null;

    return (
      <div className="accordion-body p-0">
        <div className="container accordianData">
          <div className="row">
            <div className="col-12 licence-header licence-top ps-2 py-2 info-background">
              <span>ADDITIONAL INFORMATION</span>
              <a
                className="btn-license edit-button-license "
                onClick={() => {
                  setEditId(item);
                  setOpenPopup(!openPopup);
                }}
              >
                EDIT
              </a>
              {confirmDeleteMap[item.displayId] && (
                <span>
                  <h6>Are You Sure ?</h6>
                </span>
              )}
              <a
                className="btn-license edit-button-license me-2"
                onClick={() => {
                  if (confirmDeleteMap[item.displayId]) {
                    deleteAPiCall(item.displayId);
                  } else {
                    toggleConfirmDelete(item.displayId, true);
                  }
                }}
              >
                {confirmDeleteMap[item.displayId]
                  ? "Yes"
                  : "Remove This License"}
              </a>
              {confirmDeleteMap[item.displayId] && (
                <a
                  className="btn-license edit-button-license"
                  onClick={() => toggleConfirmDelete(item.displayId, false)}
                >
                  NO
                </a>
              )}
            </div>
          </div>
          <div className="row border border-start-0 border-end-0">
            <div className="col-md-3 border-bottom border-top">
              <div className="table-content-license">
                <p className="header">Licensee Name</p>
                <p className="headerValue">
                  {providerOverviewData?.firstName +
                    (providerOverviewData?.middleName
                      ? " " + providerOverviewData.middleName
                      : "") +
                    " " +
                    providerOverviewData?.lastName}
                </p>
              </div>
            </div>
            <div className="col-md-3 border border-end-0">
              <div className="table-content-license">
                <p className="header">ISSUE DATE</p>
                <p className="headerValue">
                  {formatDateUnrelatedTimezone(selectedLicenceDataMoreDetails?.issueDate)}
                </p>
              </div>
            </div>
            <div className="col-md-3 border border-end-0 ">
              <div className="table-content-license">
                <p className="header">EXP DATE</p>
                <p className="headerValue">
                  {formatDateUnrelatedTimezone(selectedLicenceDataMoreDetails?.expirationDate,false)}
                </p>
              </div>
            </div>
            <div className="col-md-3 border border-end-0">
              <div className="table-content-license">
                <p className="header">ADDRESS</p>
                <p className="headerValue">
                  {[
                    selectedLicenceDataMoreDetails.address?.address1,
                    selectedLicenceDataMoreDetails.address?.address2,
                    selectedLicenceDataMoreDetails.address?.city,
                    selectedLicenceDataMoreDetails.address?.state,
                    selectedLicenceDataMoreDetails.address?.postalCode,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {RenderDisciplinaryActionData(item.displayId)}
          </div>
          <div className="row showLess">
            <div className="showLessButtonContainer">
              <button
                className="accordion-button collapsed custom-arrow-color"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#collapseOne" + index}
                aria-expanded="false"
                aria-controls={"collapseOne" + index}
                onClick={() => {
                  setOpenAccordian({
                    ...openAccordian,
                    [item.displayId]: false,
                  });
                }}
              >
                <span style={{ color: "#0077b7", fontSize: "12px" }}>
                  Show Less
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderAccordian = () => {
    return (
      <div className="accordion" id="accordionSection">
        <div>
          {LicenseData?.map((item, index) => {
            return (
              <>
                <div className="accordion-item border mb-4 ">
                  <div className="accordion-header">
                    <div className="d-flex ">
                      <div className="col-md-1 border-bottom border-top-0 statusCode">
                        <p className="bigHeaderValue">{item.stateCode}</p>
                      </div>
                      <div className="col-md-4 border border-end-0 border-top-0">
                        <div className="table-content-license">
                          <p className="header">Number</p>
                          <p className="headerValue">{item.number}</p>
                        </div>
                      </div>
                      <div className="col-md-3 border border-end-0 border-top-0">
                        <div className="table-content-license">
                          <p className="header">Status</p>
                          {!item.boardStatus ? (
                            <p className="headerValue">{item.displayStatus}</p>
                          ) : (
                            <OutsideClickHandler
                              isInLineFlex={true}
                              onClickOutside={() => {
                                if (
                                  boardStatusPracticeDisId === item.displayId
                                ) {
                                  setBoardStatusPracticeDisId("");
                                }
                              }}
                            >
                              <p className="headerValue">
                                {item.displayStatus}
                              </p>
                              <span className="board-status-popup-relative-span">
                                <img
                                  className="board-status-icon"
                                  alt
                                  src={boardStatusIcon}
                                  onClick={() => {
                                    if (
                                      boardStatusPracticeDisId ===
                                      item.displayId
                                    ) {
                                      setBoardStatusPracticeDisId("");
                                    } else {
                                      setBoardStatusPracticeDisId(
                                        item.displayId
                                      );
                                    }
                                  }}
                                />

                                {boardStatusPracticeDisId === item.displayId ? (
                                  <span className="practice-popover-contect">
                                    <span className="arrow"></span>
                                    <p>
                                      <b>Board Status:</b> {item.boardStatus}
                                    </p>
                                  </span>
                                ) : null}
                              </span>
                            </OutsideClickHandler>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 border border-end-0 border-top-0">
                        <div className="table-content-license">
                          <p className="header">Type</p>
                          <p className="headerValue">{item.type}</p>
                        </div>
                      </div>
                    </div>
                    {!openAccordian[item.displayId] && (
                      <button
                        border
                        className="accordion-button collapsed custom-arrow-color"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapseOne" + index}
                        aria-expanded="false"
                        aria-controls={"collapseOne" + index}
                        onClick={() => {
                          setSelectedLicense(item?.displayId);
                          handleGetDetails(item);
                          // });
                          setOpenAccordian({
                            ...openAccordian,
                            [item.displayId]: true,
                          });
                        }}
                      >
                        <span style={{ color: "#0077b7", fontSize: "12px" }}>
                          Details & Actions
                        </span>
                      </button>
                    )}
                  </div>
                  <div
                    id={"collapseOne" + index}
                    className={`accordion-collapse collapse ${
                      openAccordian[item.displayId] ? "show" : ""
                    }`}
                    data-bs-parent="#accordionLicense"
                  >
                    {RenderLicenseMoreDetails(item, index)}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    );
  };

  const RenderNoLicenseData = () => {
    if (LicenseData.length > 0) return null;
    return (
      <div className="noDataInformationWrapper">
        No License data for this provider
      </div>
    );
  };

  const RenderLicenseAddEdit = () => {
    const RenderFormCreator = () => {
      const licenseAddSchema = [
        {
          component: "dropdown",
          label: "STATE",
          name: "stateCode",
          dropdownOptions: stateData,
          onSelectCallBack: (name, value) => {
            setStateCode(value);
            dispatch(fetchLicenseTypes(value));
          },
          required: true,
        },
        {
          component: "dropdown",
          label: "TYPE",
          name: "type",
          dropdownOptions: dropdownTypeData,
          disabled: stateCode ? false : true,
          onSelectCallBack: (res, value, metaData) => {
            setSelectedTypeItem(metaData);
          },
        },
        {
          component: "input",
          label: "NUMBER",
          type: "text",
          name: "number",
          valueChangeCallback: (name, value) => {
            setLicenseNumber(value);
          },
          onKeyChangeCallback: (name, value) => {
            setLicenseNumber(value);
          },
        },
        {
          component: "dropdown",
          label: "STATUS",
          name: "displayStatus",
          dropdownOptions: StatusData,
          onSelectCallBack: () => {},
        },
        {
          component: "input",
          label: "ISSUE DATE",
          type: "date",
          name: "issueDate",
          customDateDisplay: true,
          showCheckbox: true,
          placeholder: "mm/dd/yyyy",
          onCheckboxValueChange: () => {},
          checkboxLabel: "Valid issue date not found",
          valueChangeCallback: () => {},
          shouldRenderInputCheckboxWithBackgroundImageStyle: true,
        },
        {
          component: "input",
          label: "EXPIRATION DATE",
          type: "date",
          placeholder: "mm/dd/yyyy",
          customDateDisplay: true,
          name: "expirationDate",
          valueChangeCallback: () => {},
        },
      ];

      const licenseEditSchema = [
        {
          component: "dropdown",
          label: "STATUS",
          name: "displayStatus",
          dropdownOptions: StatusData,
          defaultValue: editId ? editId.displayStatus : "",
          onSelectCallBack: (name, value) => {
            // if (value) {
            //   setEnableEditSaveBtn(true);
            // } else {
            //   setEnableEditSaveBtn(false);
            // }
            setEnableEditSaveBtn(true);
            console.log(value);
          },
        },
        {
          component: "input",
          label: "ISSUE DATE",
          type: "date",
          name: "issueDate",
          // id: "edit-issueDate",
          placeholder: "mm/dd/yyyy",
          customDateDisplay: true,
          defaultValue: convertToDateFormat(licenceDataMoreDetails.issueDate),
          // defaultValue: editId ? licenceDataMoreDetails.issueDate : "",
          showCheckbox: true,
          onCheckboxValueChange: () => {},
          checkboxDefaultValue: licenceDataMoreDetails.issueDate ? false : true,
          checkboxLabel: "Valid issue date not found",
          valueChangeCallback: () => {},
          shouldRenderInputCheckboxWithBackgroundImageStyle: true,
        },
        {
          component: "input",
          label: "EXPIRATION DATE",
          type: "date",
          placeholder: "mm/dd/yyyy",
          customDateDisplay: true,
          name: "expirationDate",
          // id: "edit-expirationDate",
          defaultValue: convertToDateFormat(
            licenceDataMoreDetails.expirationDate
          ),
          // defaultValue: editId ? licenceDataMoreDetails.expirationDate : "",
          // defaultValue: "06/04/2025",
          valueChangeCallback: () => {},
        },
      ];

      const handleSubmitValue = (res) => {
        const { number, displayStatus, expirationDate, issueDate } = res;

        // Check if issue date is in the future
        if (issueDate) {
          const today = new Date();
          const [month, day, year] = issueDate.split("/");
          const issueDateObj = new Date(year, month - 1, day);

          if (issueDateObj > today) {
            setShowFutureErrorMsg(true);
            setTimeout(() => {
              setShowFutureErrorMsg(false);
            }, 3000);
            return;
          }
        }

        const payload = {
          licenseTypeDisplayId: selectedTypeItem?.id,
          number,
          expirationDate: expirationDate,
          status: displayStatus,
          issueDateUnavailable: !res.issueDate ? true : false,
          issueDate,
        };
        dispatch(fetchAddLicenses({ providerId: prvId, data: payload })).then(
          () => {
            dispatch(fetchLicenseInformation(prvId)).then(() => {
              closePopupCallback();
            });
          }
        );
        setOpenPopup(!openPopup);
      };

      const handleUpdateEditedValue = (val) => {
        const { displayStatus, issueDate, expirationDate } = val;
        const payload = {
          status: displayStatus !== "" && displayStatus,
          issueDateUnavailable: !issueDate ? true : false,
          issueDate: !issueDate ? "" : issueDate ? issueDate : editId.issueDate,
          expirationDate: expirationDate
            ? expirationDate
            : editId.expirationDate,
        };
        // if (expirationDate) {
        //   payload.expirationDate = expirationDate;
        // }
        // if (issueDate) {
        //   payload.issueDate = issueDate;
        // }

        dispatch(
          fetchUpdateLicenses({
            providerId: prvId,
            licenseId: editId?.displayId,
            data: payload,
          })
        ).then(() => {
          dispatch(fetchLicenseInformation(prvId)).then(() => {
            closePopupCallback();
          });
          dispatch(
            fetchLicenseMoreDetails({
              providerId: prvId,
              licenseId: editId?.displayId,
            })
          );
        });
        setOpenPopup(!openPopup);
        setEditId("");
      };

      return (
        <div className="editProviderWrapper">
          {showFutureErrorMsg && (
            <div
              className="alert alert-danger"
              role="alert"
              style={{ position: "absolute", width: "80%", top: "15%" }}
            >
              <b>Error</b>
              <p>Issue date cannot be in the future</p>
            </div>
          )}
          <CgFormCreator
            key={`${LicenseData}-${editId?.displayId}-${licenceDataMoreDetails?.issueDate}-${licenceDataMoreDetails?.expirationDate}`}
            enablePrimaryBtn={editId ? enableEditSaveBtn : enableLicenseSaveBtn}
            onSubmitCallback={(res) => {
              if (!editId) {
                handleSubmitValue(res);
              } else {
                handleUpdateEditedValue(res);
              }
              // closePopupCallback();
            }}
            resetValuesOnSubmit={false}
            onCancel={() => {
              setOpenPopup(false);
              setEditId("");
              closePopupCallback();
            }}
            needFormHeader
            formHeader="LICENSE"
            formClassName={
              editId
                ? "providerLicenseEditWrapper"
                : "providerLicenseFormWrapper"
            }
            schema={editId ? licenseEditSchema : licenseAddSchema}
          />
        </div>
      );
    };

    return (
      <>
        <div className="addLicense">
          <PopupModal
            customRender={RenderFormCreator}
            isOpen={openPopup}
            onClose={() => {
              setOpenPopup(!openPopup);
              setEditId(null);
              console.log("closePopupCallback();");
              setEditClicked(false);
              closePopupCallback();
            }}
            className={editId ? "editPopup" : "addpopup"}
            onSave={() => {
              // handleAddLicenseData();
              setOpenPopup(!openPopup);
              closePopupCallback();
            }}
            popupHeading={
              editId
                ? `${editId.stateCode} ${editId.type} : ${editId.number}`
                : "LICENSE INFORMATION"
            }
          />
        </div>
      </>
    );
  };

  const RenderDisciplinaryAction = () => {
    const RenderDisciplinaryActionFormCreator = () => {
      if (!editClicked) return <div> Loading ... </div>;

      const handleAddDisciplinaryActionData = (res) => {
        const { actionDate, description, notes, status } = res;

        const payload = {
          licenseDisplayId: activeLicenseId,
          actionDate,
          description,
          status,
          note: notes,
        };
        const filesWithDescriptions = rawFile.map((fileItem) => ({
          ...fileItem,
          description:
            fileItem.description || fileDesc || fileItem.FILE?.name || "",
        }));
        dispatch(
          fetchAddDisciplinaryActions({ providerId: prvId, data: payload })
        ).then(async (addResult) => {
          if (!addResult.payload?.success) {
            return;
          }
          const actionDisplayId = getDisciplinaryActionDisplayIdFromResponse(
            addResult.payload
          );
          await uploadDisciplinaryBoardDocuments(
            actionDisplayId,
            filesWithDescriptions
          );
          refreshDisciplinaryDetails(activeLicenseId);
          resetDisciplinaryFileState();
          setPopupDisciplinaryActions(!openPopupDisciplinaryActions);
          setEditClicked(false);
          setdisciplinaryActionsEditId(null);
        });
      };

      const handleUpdateDisciplinaryActionData = (res) => {
        const payload = {
          licenseDisplayId: selectedLicense,
          displayId: disciplinaryActionsEditId.displayId,
          actionDate: res.actionDate
            ? res.actionDate
            : disciplinaryActionsEditId.actionDate,
          description: res.description
            ? res.description
            : disciplinaryActionsEditId.description,
          status: res.status ? res.status : disciplinaryActionsEditId.status,
          note: res.notes
            ? res.notes
            : disciplinaryActionsEditId.note ?? disciplinaryActionsEditId.notes,
          reviewUser: "udayraj.n@evernorth.com",
          isValidated: "false",
        };
        const filesWithDescriptions = rawFile.map((fileItem) => ({
          ...fileItem,
          description:
            fileItem.description || fileDesc || fileItem.FILE?.name || "",
        }));

        dispatch(
          fetchUpdateDisciplinaryActions({
            providerId: prvId,
            licenseId: selectedLicense,
            data: payload,
          })
        ).then(async (updateResult) => {
          if (!updateResult.payload?.success) {
            return;
          }
          await uploadDisciplinaryBoardDocuments(
            disciplinaryActionsEditId.displayId,
            filesWithDescriptions
          );
          refreshDisciplinaryDetails(selectedLicense);
          resetDisciplinaryFileState();
          setPopupDisciplinaryActions(!openPopupDisciplinaryActions);
          setEditClicked(false);
          setdisciplinaryActionsEditId(null);
        });
      };

      return (
        <div className="licenseform-without-border-style disciplinaryActionForm">
          <CgFormCreator
            onSubmitCallback={(res) => {
              if (!disciplinaryActionsEditId) {
                handleAddDisciplinaryActionData(res);
                setdisciplinaryActionsEditId(null);
              } else {
                console.log("called");
                handleUpdateDisciplinaryActionData(res);
              }
              setEditClicked(false);
            }}
            enablePrimaryBtn={enableDisciplinaryActionSaveBtn}
            onCancel={() => {
              setPopupDisciplinaryActions(false);
              setEditClicked(false);
              resetDisciplinaryFileState();
            }}
            // canFormCreatorValidateTheForm={true}
            schema={disciplinaryActionAddEditSchema}
          />
        </div>
      );
    };
    return (
      <>
        <PopupModal
          customRender={RenderDisciplinaryActionFormCreator}
          isOpen={openPopupDisciplinaryActions}
          onClose={() => {
            setPopupDisciplinaryActions(!openPopupDisciplinaryActions);
            setdisciplinaryActionsEditId(null);
            setEditClicked(false);
            resetDisciplinaryFileState();
          }}
          onSave={() => {
            setPopupDisciplinaryActions(!openPopupDisciplinaryActions);
          }}
          popupHeading="DISCIPLINARY ACTION"
        />
      </>
    );
  };

  const RenderLicenseHeader = () => {
    return (
      <div className="license-container">
        <div className="licence-header licence-top">
          <span>License ({LicenseData.length})</span>
          <a
            className="btn-license edit-button-license"
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
          >
            + ADD
          </a>
        </div>
      </div>
    );
  };

  const RenderErrors = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        {licenseErrorMsg}
      </div>
    );
  };

  return (
    <div className="providerLicenseWrapper">
      {!onlyPopup && (
        <>
          {RenderErrors()}
          {RenderLicenseHeader()}
          {RenderAccordian()}
          {RenderNoLicenseData()}
          {RenderDisciplinaryAction()}
        </>
      )}
      {RenderLicenseAddEdit()}
    </div>
  );
};

export default ProviderLicenseSection;
